import script from "./school_teaching_eval.vue?vue&type=script&setup=true&lang=ts"
export * from "./school_teaching_eval.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__